import { useState, useRef } from 'react';
import { Play, Pause } from 'lucide-react';

/**
 * Simple audio preview player used on the Beats page.
 * Exports a named component to keep the import style consistent across pages.
 */
export function BeatPlayer({ beatId, src }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) audioRef.current.pause();
    else audioRef.current.play().catch(() => {});
    setPlaying(!playing);
  };

  return (
    <div className="flex items-center gap-3">
      <audio
        ref={audioRef}
        src={src}
        onTimeUpdate={() => {
          const a = audioRef.current;
          if (a && a.duration) setProgress((a.currentTime / a.duration) * 100);
        }}
        onEnded={() => setPlaying(false)}
      />
      <button
        onClick={toggle}
        className="w-8 h-8 flex items-center justify-center text-[#A3A3A3] hover:text-[#FF3B30] transition-colors"
        data-testid={`play-beat-${beatId}`}
      >
        {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
      </button>
      <div
        className="flex-1 bg-[#262626] h-1 cursor-pointer"
        onClick={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const pct = (e.clientX - rect.left) / rect.width;
          if (audioRef.current) audioRef.current.currentTime = pct * audioRef.current.duration;
        }}
      >
        <div className="bg-[#FF3B30] h-full transition-all" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
